/* istanbul ignore file */
import { Box } from '@mui/material';
import { CreateForm, TextInput } from 'framework/form';
import { usePrivilegedCandidateId } from '../../privilegedAccessRouting';
import { useExternalAccountsService } from '../externalAccountsService';
import { InputTooltip, CreatePageLayout, FormSection, FormRow } from 'framework/ui/layout';
import { useCandidateService, useCandidateUrl } from 'domain/shared/candidate';
import useDeprovisionResponseHandler from './accountsDeprovisionResponseHandler';

const InternAccountsDeprovisionForm = () => {
  const candidateId = usePrivilegedCandidateId();
  const { getById } = useCandidateService();
  const { getProfileEditUrl } = useCandidateUrl();
  const { deprovisionExternalAccounts } = useExternalAccountsService();
  const { handleDeprovisionResponse } = useDeprovisionResponseHandler();

  const submitFormFunc = async () => {
    const response = await deprovisionExternalAccounts({ candidateId });
    handleDeprovisionResponse(response);
  };

  return (
    <CreateForm
      getDataFunc={() => getById(candidateId)}
      submitFormFunc={submitFormFunc}
      afterSubmit={{
        execute: () => {},
      }}
    >
      <CreatePageLayout title="Deprovision: Azure, Redmine and GitLab accounts">
        <FormSection title="Intern account information">
          <FormRow>
            <TextInput label="First name" source="name.firstName" disabled />
            <TextInput label="Last name" source="name.lastName" disabled />
          </FormRow>
          <FormRow>
            <TextInput label="Syberry Email" source="syberryEmail" disabled />
            <TextInput label="Azure ID" source="azureId" disabled />
          </FormRow>
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <a href={getProfileEditUrl(candidateId)} target="_blank" rel="noreferrer">
              Open candidate profile
            </a>
            <InputTooltip
              message="Reload page to get profile changes"
              source=""
              size="small"
              sx={{ marginLeft: '10px' }}
            />
          </Box>
        </FormSection>
      </CreatePageLayout>
    </CreateForm>
  );
};

export default InternAccountsDeprovisionForm;
